import { HotelDetailCreate } from './HotelDetailCreate'
import { HotelDetailEdit } from './HotelDetailEdit'
import { HotelDetailList } from './HotelDetailList'
import { HotelDetailShow } from './HotelDetailShow'

export { HotelDetailCreate, HotelDetailEdit, HotelDetailList, HotelDetailShow }
